import { Avatar } from "@infinitaslearning/auth-client"
import { useEffect } from "react"
import type { ReactElement } from "react"
import { LicenceSwitcher } from ".."
import { LanguageSwitcher } from ".."
import { useIsSafeExamBrowser, useIsWildcardUser } from "../../../hooks"
import { fetchUserLicenceInfo, history } from "../../../redux"
import type { AppState, AppThunkDispatch, UserActions } from "../../../redux"
import { LinkButton } from "../../atoms"

import "./avatar-wrapper.styles.scss"
import { Box, Button } from "@material-ui/core"
import TourIcon from "@mui/icons-material/Tour"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { config } from "../../../config"
import { useFeatureFlag } from "../../../hooks/useFeatureFlag"
import { SettingFlags } from "../../../models"

export interface IAvatarWrapperStateProps {
  userLicences?: string[]
  fetchUserLicences: () => void
}

function AvatarWrapperView(props: IAvatarWrapperStateProps): ReactElement {
  const { userLicences, fetchUserLicences } = props
  const { t } = useTranslation("avatar")
  const isWildcardUser = useIsWildcardUser()
  const isSafeExamBrowser = useIsSafeExamBrowser()

  const { value: isContentManagerVisible } = useFeatureFlag(SettingFlags.toggleContentManager, false)
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    fetchUserLicences()
  }, [])
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    if (!userLicences) return
    if (!isWildcardUser && localStorage.getItem(config.selectedLicenceLocalstorageKey) !== null) {
      localStorage.removeItem(config.selectedLicenceLocalstorageKey)
      window.location.reload()
    }
  }, [userLicences])

  return (
    <Avatar hideDefaultLinks={isSafeExamBrowser}>
      {!isSafeExamBrowser && (
        <Box id="avatar-custom-links" display="flex" flexDirection="column" alignItems="flex-start">
          {isContentManagerVisible && (
            <LinkButton
              onClick={() => {
                history.push("/manage")
              }}
            >
              {t("contentManager")}
            </LinkButton>
          )}

          <Button id="usetiful-button" onClick={() => document.getElementById("account_close-menu-btn")?.click()}>
            <TourIcon />
            {t("tourButton")}
          </Button>
          {isWildcardUser && <LicenceSwitcher />}
          {isWildcardUser && <LanguageSwitcher />}
        </Box>
      )}
    </Avatar>
  )
}

function mapStateToProps(state: AppState) {
  return {
    userLicences: state.user.licences
  }
}

function mapDispatchToProps(dispatch: AppThunkDispatch<UserActions>) {
  return {
    fetchUserLicences: () => dispatch(fetchUserLicenceInfo())
  }
}

export const AvatarWrapper = connect(mapStateToProps, mapDispatchToProps)(AvatarWrapperView)
